var ContextRegistry = require('./contextRegistry');

var TAGS = {
  anchor: 'A',
  button: 'BUTTON',
  html: 'HTML',
  input: 'INPUT'
};
var TAG_WHITELIST = [TAGS.anchor, TAGS.button, TAGS.input];
var INPUT_TYPES = ['submit', 'reset'];
var DATA_ATTRIBUTES = ['category', 'section', 'action', 'type', 'label', 'name', 'value'];
var DOM_ATTRIBUTES = ['class', 'id', 'href'];
var TRACKABLE_ATTRIBUTES = DATA_ATTRIBUTES.concat(DOM_ATTRIBUTES);
var dataAttributesMapping = buildMapping(DATA_ATTRIBUTES);

var ClickTracker = function() {
  this.context = new ContextRegistry();
}

ClickTracker.prototype.register = function(trackingCallback) {
  this.trackingCallback = trackingCallback;
  document.addEventListener('click', this.clickHandler.bind(this), true);
}

ClickTracker.prototype.setContext = function(type, data) {
  this.context.setContext(type, data)
}

ClickTracker.prototype.clearContext = function(type) {
  this.context.clearContext(type)
}

ClickTracker.prototype.clickHandler = function(event) {
  var element = findTrackableElement(event.target);

  if (element) {
    var trackingObject = createTrackingObject(element);
    var trackingPayload = this.createPayload(trackingObject);

    this.trackingCallback(trackingPayload);
  }
}

ClickTracker.prototype.createPayload = function(trackingObject) {
  return {
    data: cleanData(trackingObject),
    contexts: this.context.list()
  }
}

function findTrackableElement(element) {
  if (isEndOfDocument(element)) { return null; }
  else if (isWhitelisted(element) || isExplicitlyTracked(element)) { return element; }
  else { return findTrackableElement(element.parentNode); }
}

function createTrackingObject(trackableElement) {
  var trackingObject = buildTrackingObject(trackableElement);
  return backFillData(trackableElement, trackingObject);
}

function buildTrackingObject(element, trackingObject) {
  if (trackingObject === undefined) {
    trackingObject = newTrackingObjectInstance();
  }

  if (isEndOfDocument(element) || dataAttributesFilled(trackingObject)) { return trackingObject; }

  fillDataFields(element, trackingObject);
  return buildTrackingObject(element.parentNode, trackingObject);
}

function newTrackingObjectInstance() {
  return TRACKABLE_ATTRIBUTES.reduce(function(trackingObject, attribute) {
    trackingObject[attribute] = null;

    return trackingObject;
  }, {});
}

function fillDataFields(element, trackingObject) {
  var dataAttributes = element.dataset;
  if (!dataAttributes) { return }

  DATA_ATTRIBUTES.forEach(function(attribute) {
    trackingObject[attribute] = trackingObject[attribute] || dataAttributes[dataAttributesMapping[attribute]] || null;
  });
}

function dataAttributesFilled(trackingObject) {
  var attributeValues = DATA_ATTRIBUTES.map(function(attribute) {
    return trackingObject[attribute];
  });

  var nullValues = attributeValues.filter(function(value) { return value === null });

  if (nullValues.length > 0) { return false; }
  return true;
}

function backFillData(originElement, trackObject) {
  switch (originElement.tagName) {
    case TAGS.input: {
      if (INPUT_TYPES.indexOf(originElement.type) != -1) {
        backFillButtonData(originElement, trackObject);
        break;
      }
    }
    case TAGS.button: {
      backFillButtonData(originElement, trackObject);
      break;
    }
    case TAGS.anchor: {
      backFillAnchorData(originElement, trackObject);
      break;
    }
  }

  return backfillSelectors(originElement, trackObject);
}

function backfillSelectors(element, trackingObject) {
  trackingObject.class = element.className || null;
  trackingObject.id = element.id || null;

  return trackingObject;
}

function backFillAnchorData(element, trackingObject) {
  trackingObject.label = trackingObject.label || element.innerText;
  trackingObject.type = trackingObject.type || 'link';
  trackingObject.href = element.href || null;

  return trackingObject;
}

function backFillButtonData(element, trackingObject) {
  trackingObject.label = trackingObject.label || element.innerText;
  trackingObject.action = trackingObject.action || element.type;
  trackingObject.type = trackingObject.type || element.type || 'button';
  trackingObject.href = element.formAction || null;

  return trackingObject;
}

function buildMapping(attributes) {
  return attributes.reduce(function(mappedObject, attribute) {
    var capitalizedAttribute = attribute[0].toUpperCase() + attribute.substring(1);
    mappedObject[attribute] = 'track' + capitalizedAttribute;

    return mappedObject;
  }, {});
}

function isEndOfDocument(element) {
  return element.tagName === TAGS.html;
}

function isWhitelisted(element) {
  return TAG_WHITELIST.indexOf(element.tagName) != -1;
}

function isExplicitlyTracked(element) {
  // ie11 guard against elements which do not contain a dataset reference (SVGs)
  return !!(element.dataset && element.dataset['trackable'])
}

function cleanData(object) {
  Object.keys(object).forEach(function(key) {
    if (object[key] === null) {
      delete object[key];
    }
  })

  return object
}

module.exports = ClickTracker;
